import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { FilterClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import { ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER, EVENT_CHANNEL, EVENT_SOURCE } from "../../../../../constants/analytics/events";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import InternalFacetDropdown from "./InternalFacetDropdown";

class DisjunctiveFacetDropdown extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onDisjunctiveFacetRemoveClick", e => {
      this.props.items.reduce((filters, i) => {
        if (i.selected) {
          const newFilters = filters.update(i.facetKey, f => f.delete(i.facetValue));
          this.props.fireAnalyticsEvent({
            eventType: FilterClickedEvent,
            actionSubjectId: ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER,
            source: EVENT_SOURCE,
            attributes: {
              currentPerspective: this.props.perspective,
              filterKey: i.facetKey,
              filterValue: i.facetValue,
              selected: false
            }
          }, EVENT_CHANNEL);
          this.props.stateChangeRequested({
            filters: newFilters
          });
          return newFilters;
        }

        return filters;
      }, this.props.filters);
      e.stopPropagation();
    });
  }

  render() {
    const numberSelectedItems = this.props.items.filter(i => i.selected).size;
    const someSelectedItemsExist = numberSelectedItems > 0;
    const label = someSelectedItemsExist ? "".concat(numberSelectedItems, " selected") : this.props.label;
    return /*#__PURE__*/React.createElement(InternalFacetDropdown, {
      closeOnItemSelected: false,
      facetBar: this.props.facetBar,
      facetValue: this.props.label,
      filters: this.props.filters,
      hasSelectedItem: someSelectedItemsExist,
      items: this.props.items,
      label: label,
      onItemActivated: this.props.onItemActivated,
      onRemoveClick: this.onDisjunctiveFacetRemoveClick,
      perspective: this.props.perspective
    });
  }

}

_defineProperty(DisjunctiveFacetDropdown, "propTypes", {
  facetBar: PropTypes.oneOf(['top', 'side']),
  fireAnalyticsEvent: PropTypes.func.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  items: ImmutablePropTypes.list.isRequired,
  label: PropTypes.string.isRequired,
  onItemActivated: PropTypes.func.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});

export default withAnalytics(DisjunctiveFacetDropdown);